import { render, staticRenderFns } from "./internal35New.vue?vue&type=template&id=b6145b32&scoped=true&"
import script from "./internal35New.vue?vue&type=script&lang=ts&"
export * from "./internal35New.vue?vue&type=script&lang=ts&"
import style0 from "./internal35New.vue?vue&type=style&index=0&id=b6145b32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6145b32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zfh/dev/targus-micor/targus-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6145b32')) {
      api.createRecord('b6145b32', component.options)
    } else {
      api.reload('b6145b32', component.options)
    }
    module.hot.accept("./internal35New.vue?vue&type=template&id=b6145b32&scoped=true&", function () {
      api.rerender('b6145b32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/home/modules/login/internal35New.vue"
export default component.exports